import { PatientBackgroundI } from '@interfaces/patient/patient-backgroundI';
import { BaseStateI } from '@interfaces/redux/base-state';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { readPatientBackground } from '@services/patient';

export interface PatientBackgroundState extends BaseStateI{
    patientBackground: PatientBackgroundI | null;
   
};

const fetchPatientBackground = createAsyncThunk(
    'patient/fetchPatientBackground',
    async (patientData: { patientId: number; lang: string }, thunkAPI) => {
        const data = await readPatientBackground(
            patientData.patientId,
            patientData.lang
        );
        return data;
    }
);

const patientBackgroundSlice = createSlice({
    name: 'patient-background',
    initialState: {
        error: null,
        patientBackground: null,
        status: 'idle',
    } as (PatientBackgroundState),
    reducers: {
        resetPatient: (state) => {
            state.error = null;
            state.patientBackground = null;
            state.status = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPatientBackground.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(fetchPatientBackground.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
        });
        builder.addCase(fetchPatientBackground.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.patientBackground = action.payload;
        });
    },
});

export const { resetPatient } = patientBackgroundSlice.actions;
export default patientBackgroundSlice.reducer;
